import { useCallback } from 'react';
import { useState } from 'react';

interface UseToggleOptions {
  initialState?: boolean;
}

type UseTogglePayload = [state: boolean, toggleState: () => void];

/**
 * Hook for controlling toggle state
 */
export const useToggle = (options?: UseToggleOptions): UseTogglePayload => {
  const [state, setState] = useState<boolean>(options?.initialState ?? false);

  const toggleState = useCallback(() => {
    setState((prev) => !prev);
  }, []);

  return [state, toggleState];
};
